module.exports = __webpack_public_path__ + "img/2.c830488c.png";